import { top, right, bottom, left, phaseWidth } from "../const"

export type Side = typeof top | typeof right | typeof bottom | typeof left
export interface PhaseSideGui {
    side: Side
    linePoints: number[]
    x: number
    y: number
}
export type PhaseGui = { [side in Side]: PhaseSideGui }

export const GetPhaseGui = (titleHeight: number) => {
    const borderWidth = phaseWidth + 1
    const borderHeight = titleHeight + 1
    const topPos = -1

    const gui: PhaseGui = {
        [top]: {
            side: top,
            linePoints: [topPos, topPos, borderWidth, topPos],
            x: borderWidth / 2,
            y: topPos,
        },
        [right]: {
            side: right,
            linePoints: [borderWidth, topPos, borderWidth, borderHeight],
            x: borderWidth,
            y: borderHeight / 2,
        },
        [bottom]: {
            side: bottom,
            linePoints: [topPos, borderHeight, borderWidth, borderHeight],
            x: borderWidth / 2,
            y: borderHeight,
        },
        [left]: {
            side: left,
            linePoints: [topPos, topPos, topPos, borderHeight],
            x: topPos,
            y: borderHeight / 2,
        },
    }

    return gui
}
